import React, { useEffect } from 'react';

function Backgroundscroll(Orginalcomponent) {
  function WrappedComponent(props) {
    useEffect(() => {
      const body = document.querySelector('body');
      if (props.open) {
        body.style.overflow = 'auto';
        body.style.position = 'fixed';
        body.style.width = '100%';
        body.style.height = '100%';
      } else {
        body.style.overflow = 'auto';
        body.style.height = 'auto';
      }
      return () => {
        body.style.overflow = 'auto';
        // body.style.overflow = 'hidden';
        body.style.position = 'static';
        body.style.width = 'auto';
        body.style.height = 'auto';
      };
    }, [props.open]);

    return (
      <>
        <Orginalcomponent {...props} />
      </>
    );
  }

  return WrappedComponent;
}

export default Backgroundscroll;
